import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Button } from "@/components/ui/button";

const ShopifyCallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-4">
    <div className="text-center space-y-4">
      <h1 className="text-lg font-semibold text-foreground">Connexion boutique Shopify</h1>
      <Button variant="outline" disabled>Bientôt disponible</Button>
      <div><NotifyMeButton channel="shopify" /></div>
    </div>
  </div>
);

export default ShopifyCallback;
